import React, { createContext, useContext, useState, useEffect, useRef } from 'react';
import moment from 'moment';
import { EndPointPatiosId } from '../Services/EndPointIngresos';
import api from "../Services/ApiURLBase";
import { URLIngresosId } from "../other/apis";
// Create the Operation context
export const IngresosContext = createContext();

// Custom hook to use the Ingresos context
export const useIngresos = () => {
  const context = useContext(IngresosContext);
  if (!context) {
    throw new Error('useIngresos must be used within an IngresosProvider');
  }
  return context;
};

// Provider component
export const IngresosProvider = ({ children }) => {
  const [miningSite, setMiningSite] = useState(0);
  const [warehouse, setWarehouse] = useState(0);
  const [fromDay, setFromDay] = useState(moment().subtract(1, 'month'));
  const [selected, setSelected] = useState(null);
  const [toDay, setToDay] = useState(moment());
  const [warehouses, setWarehouses] = useState([]);
  const [ingresos, setIngresos] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const prevMiningSiteRef = useRef(miningSite);
  const isInitialRender = useRef(true);

  const fetchIngresos = async () => {
    try {
      const response = await api.get(
        URLIngresosId(
          page,
          miningSite,
          warehouse,
          moment(fromDay).utc().valueOf(),
          moment(toDay).utc().valueOf()
        )
      );

      const ingresosData = response.data.result || {};
      setIngresos(ingresosData.inputs || []);
      setTotalPages(ingresosData.totalPages || 0);
    } catch (error) {
      console.error('Error fetching ingresos:', error);
    }
  };

  const fetchYards = async () => {
    try {
      const response = await EndPointPatiosId('0');
      const warehousesData = response.data.data || [];
      setWarehouses(warehousesData);
    } catch (error) {
      console.error('Error fetching yards:', error);
    }
  };

  useEffect(() => {
    fetchYards();
    fetchIngresos();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (isInitialRender.current) {
      isInitialRender.current = false;
      return;
    }

    const miningSiteChanged = prevMiningSiteRef.current !== miningSite;
  
    if (miningSiteChanged) {
      prevMiningSiteRef.current = miningSite;
      if (warehouse !== 0) {
        setWarehouse(0);
        return;
      }
    }
    
    fetchIngresos();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [miningSite, warehouse, toDay, fromDay, page]);

  const contextValue = {
    miningSite,
    warehouse,
    warehouses,
    fromDay,
    toDay,
    ingresos,
    page,
    totalPages,
    selected,
    setSelected,
    setMiningSite,
    setWarehouse,
    setFromDay,
    setToDay,
    setPage
  };

  return (
    <IngresosContext.Provider value={contextValue}>
      {children}
    </IngresosContext.Provider>
  );
}